import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EditorGroup, Spacer } from "./EditorHelpers";
import { useRestorable, v } from "../util/useRestorable";
import { PresetTextEditor } from "../components/TextEditor";
import { PresetColorEditor } from "../components/ColorPicker";



export interface GreenHeaderProps {
  bigHeader: string;
  bigColor: string;
}

interface GreenHeaderEditorProps {
  onChange: (update: GreenHeaderProps) => void;
  flyerType: string;
  flyerLocale: string;
}


export default function GreenHeaderEditor(props: GreenHeaderEditorProps) {
  const { t } = useTranslation();
  const { onChange, flyerLocale } = props;
  const { t: dt } = useTranslation(null, { lng: flyerLocale.substring(0, 2) })
  const [bigHeader, setBigHeader] = useRestorable(dt('default.buy-european.title').toUpperCase(), 'bigHeader');
  const [bigColor, setBigColor] = useRestorable("#1F6648", 'bigColor');
  const [debouncedChange, setDebouncedChange] = useState<GreenHeaderProps | null>(null);


  // Debounce changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedChange({
        bigHeader: v(bigHeader),
        bigColor: v(bigColor),
      });
    }, 250);

    // Cleanup function to clear the timeout
    return () => {
      clearTimeout(handler);
    };
  }, [bigHeader, bigColor]);

  useEffect(() => {
    onChange(debouncedChange)
  }, [debouncedChange]);
  
  return (
    <EditorGroup>
      <PresetTextEditor 
        label={t('big-header.label')}
        value={bigHeader}
        onChange={setBigHeader} 
      />
      <PresetColorEditor 
        value={bigColor}
        onChange={setBigColor} 
      />
      <Spacer />
    </EditorGroup>
  )
}

